import Class from './c-content-chart-3d-pie';
import './c-content-chart-3d-pie@.vue';

export default Class;